angular.module('gym.mobile_app').factory('MobileAppService', ["MasqueradingService", function(MasqueradingService) {
  return {
    isInvitationAvailable: function(mobileAppSettings) {
      var masquerading;
      if (!mobileAppSettings) {
        return false;
      }
      masquerading = MasqueradingService.isMasquerading();
      if (masquerading) {
        return true;
      }
      return !(mobileAppSettings != null ? mobileAppSettings.custom_app : void 0) || (mobileAppSettings != null ? mobileAppSettings.custom_app_provisioned : void 0);
    }
  };
}]);
